<app-dialog>
  <app-dialog-title>
    <language key="CanDeactivateDialogTitle" defaultValue="Unsaved Changes"></language>
  </app-dialog-title>
  <div mat-dialog-content>
    <p class="message">
      <language
        key="CanDeactivateDialogDescription"
        defaultValue="You have unsaved changes! If you leave, your changes will be lost."
      ></language>
    </p>
  </div>
  <app-dialog-action-button (click)="dialogRef.close(false)">
    <language key="Return" defaultValue="Return"></language>
  </app-dialog-action-button>
  <app-dialog-action-button [primary]="true" (click)="dialogRef.close(true)">
    <language key="OK" defaultValue="OK"></language>
  </app-dialog-action-button>
</app-dialog>
